var escape = require("../../Tinebase/js/node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../Tinebase/js/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * CSS override for SinmpleFAQ\n * \n * @package     SimpleFAQ\n * @license     http://www.gnu.org/licenses/agpl.html AGPL Version 3\n * @author      Patrick Ryser <patrick.ryser@gmail.com>\n * @copyright   Copyright (c) 2007-2011 Metaways Infosystems GmbH (http://www.metaways.de)\n */\n\n.SimpleFAQIconCls {\n    background-image: url(" + escape(require("../../images/icon-set/icon_faq.svg")) + ") !important;\n}\n", ""]);

// exports
